import { eHocKyDangKyActionIds } from "../../action-types/category/IHocKyDangKyActions";
import { generateActions } from "../generateActions";

export const hocKyDangKyActions = {
  ...generateActions(eHocKyDangKyActionIds, "HOC_KY_DANG_KY"),
};
